export const useBackButton = (priority, handler) => {
    const callback = (ev) => ev.detail.register(priority, handler);
    const unregister = () => document.removeEventListener('ionBackButton', callback);
    document.addEventListener('ionBackButton', callback);
    return { unregister };
};
//# sourceMappingURL=back-button.js.map